export enum NotificationActions {
  Delete = 'Delete',
  DeleteAll = 'DeleteAll',
  Acknowledge = 'Acknowledge',
}
